import type {IVStoreState} from '../useIVStore.ts';

export const getImageDetails = (state: IVStoreState) => state.imagesDetails;
